import { atom } from 'recoil';

export const sideMenuForceOpen = atom<boolean>({
  key: 'sideMenuForceOpen',
  default: false,
});
